﻿/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 251025   
    This script contains functions used with dates
*/
'use strict';

const addDays = (date, days) => {
    const dt = new Date(date);
    dt.setDate(dt.getDate() + days);
    return dt;
};

const formatAsShortDate = (date) => {
    if (!(date instanceof Date)) {
        throw new Error("Invalid date object.");
    }
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;  
}

const getStartAndEndOfMonth = (currentDate = new Date()) => {
    const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const endOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    endOfMonth.setHours(23, 59, 59, 999);

    return { startOfMonth, endOfMonth };

    // Example usage:
    // const { startOfMonth, endOfMonth } = getStartAndEndOfMonth();
};

const getStartAndEndOfWeek = (currentDate = new Date()) => {
    const startOfWeek = new Date(currentDate);
    const endOfWeek = new Date(currentDate);

    // Set start of the week (Sunday)  
    startOfWeek.setDate(currentDate.getDate() - currentDate.getDay());
    startOfWeek.setHours(0, 0, 0, 0);

    // Set end of the week (Saturday)  
    endOfWeek.setDate(currentDate.getDate() + (6 - currentDate.getDay()));
    endOfWeek.setHours(23, 59, 59, 999);

    return { startOfWeek, endOfWeek };

    // Example usage:
    //const { startOfWeek, endOfWeek } = getStartAndEndOfWeek(); 
};

export {
    addDays, formatAsShortDate,
    getStartAndEndOfMonth, getStartAndEndOfWeek
}; 
